import { Injectable } from "@angular/core";
import { RemoteHttpService } from "../../remote-http";
import { FeedbackCategory } from "../../data/feedback-data";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { RemoteRequest, ContentType } from "../../remote-request";
import * as global from "../../globals";
import { Custom_RequestMethod } from '../common-service';
/*
 Generated class for the FeedbackService provider.

 See https://angular.io/docs/ts/latest/guide/dependency-injection.html
 for more info on providers and Angular 2 DI.
 */
@Injectable()
export class FeedbackService {

  constructor(private http: RemoteHttpService,
    private requestMethod: Custom_RequestMethod) {
  }

  public getCategories(): Observable<Array<FeedbackCategory>> {
    let request: RemoteRequest
      = new RemoteRequest(global.ServerUrls.listFeedbackCategories,
        this.requestMethod.get, ContentType.URL_ENCODED_FORM_DATA);

    return this.http.execute(request)
      .pipe(map((resp: any) => {
        return resp;
      }))
  }

  /**
   * Sends the feedback from a player
   * @param category The feedback category
   * @param subject The subject of the feedback
   * @param message The message
   * @returns {Observable<R>}
   */
  public sendFeedbackFromPlayer(category: string,
    subject: string,
    message: string): Observable<number> {
    let request = new RemoteRequest(global.ServerUrls.createPlayerFeedback,
      this.requestMethod.post, ContentType.URL_ENCODED_FORM_DATA, {
      category: category,
      subject: subject,
      message: message
    });
    return this.http.execute(request)
      .pipe(map((resp: any) => {
        let id = parseInt(resp.text());
        return id;
      })).pipe(catchError(this.http.handleError))
  }
}

